// extracted by mini-css-extract-plugin
export var dropdown = "_u8-0";
export var imageWrapper = "_u8-3";
export var itemNameContainer = "_u8-1";
export var productImage = "_u8-2";
export var spinnerWrapper = "_u8-4";